<template>
  <div>
    <div class="container">
      <div class="container m15">
        <!-- 面包蟹 -->
        <div class="container"
             style="height: 40px; line-height: 40px;color: #999">
          <span class="font_link_fw">
            <router-link :to="{name: 'home'}">首页</router-link>
          </span> &nbsp;&nbsp;>&nbsp;&nbsp;
          <span class="productHref">解决方案</span> &nbsp;&nbsp;>&nbsp;&nbsp;
          <span style="color:#1D65A8"
                v-if="menuIndex>-1 && solutionMenuList[menuIndex]"
                @click="choose(menuIndex)">{{solutionMenuList[menuIndex].name}}</span>
          <span style="color: #666"
                v-if="twoMenuIndex>-1&&soluData[twoMenuIndex]">&nbsp;&nbsp;>&nbsp;&nbsp;<b>{{soluData[twoMenuIndex].name}}</b></span>
          <!-- <span>{{$route.query.title}}</span>
          <span style="color: #666" v-show="$route.query.title1">&nbsp;&nbsp;/&nbsp;&nbsp;<b>{{$route.query.title1}}</b></span> -->
        </div>
      </div>
      <!-- 第一级分类 -->
      <div class="container"
           style="background-color: #ffffff;">
        <div style="height:40px;margin: 10px 0px;">
          <span class="yjlm"
                :class="{yjlmactive : menuIndex == index}"
                v-for="(item,index) in solutionMenuList"
                :key="item.id"
                @click="choose(index)">{{item.name}}</span>
        </div>
      </div>
      <!-- 第二级分类 -->
      <div class="container"
           style="background-color: #ffffff;">
        <div style="height:40px;margin: 10px 0px;">
          <span class="yjlm ejlm"
                :class="{ejlmac : twoMenuIndex == -1}"
                @click="choose(menuIndex)">全部</span>
          <span class="yjlm ejlm"
                :class="{ejlmac : twoMenuIndex == index}"
                v-for="(item,index) in soluData"
                :key="index"
                @click="chooseTwo(index)">{{item.name}}</span>
        </div>
      </div>
      <div>
        <el-row :gutter="16"
                class="goods-box"
                v-if="soluDataList.length">
          <div class="goods-show-info"
               v-for="(item, index) in soluDataList"
               :key="index"
               @click="jumpToDetail(item.name, item.solutionId)">
            <div class="goods-show-img imgAuto">
              <img :src="item.thumbnailUrl || 'static/img/占位图.png'"
                   class="ssimg"
                   :alt="item.name" />
            </div>
            <div class="goods-show-detail">
              <div :title="item.name"
                   style="width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                {{item.name || ''}}<br>
                <span style="fontSize:12px;line-height:1.5em;color:#999">{{item.desc || ''}}</span>
              </div>
            </div>
          </div>
        </el-row>
        <el-row v-else>
          <div style="text-align:center">
            <img src='@/assets/img/good/noGood.png'
                 alt="暂无数据" />
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import { solutionDetail } from '@/utils/eventTracking'
export default {
  name: 'planList',
  data () {
    return {
      // 解决方案一级数据
      solutionMenuList: [],
      menuIndex: 0,
      // 解决方案二级数据
      soluData: [],
      twoMenuIndex: 0,
      // 解决方案三级数据
      soluDataList: [],
      yjlmactive: '',
      ejlmac: ''
    }
  },
  computed: {},
  watch: {
    $route (to, from) {
      this.updataData()
    }
  },
  methods: {
    // 点击一级菜单
    choose (index) {
      this.yjlmactive = index
      this.menuIndex = index
      this.twoMenuIndex = -1
      this.soluData = this.solutionMenuList[index] && this.solutionMenuList[index].children ? this.solutionMenuList[index].children : []
      let soluDataList = []
      if (this.soluData.length > 0) {
        this.soluData.forEach(plan => {
          if (plan.children && plan.children.length > 0) {
            soluDataList.push(...plan.children)
          }
        })
      }
      this.soluDataList = soluDataList
    },
    // 点击二级菜单
    chooseTwo (index) {
      this.ejlmac = index
      this.twoMenuIndex = index
      this.soluDataList = this.soluData[index] && this.soluData[index].children ? this.soluData[index].children : []
    },
    // 路由更改
    updataData () {
      let soluData = []
      let menuIndex = -1
      let twoMenuIndex = -1
      let soluDataList = []
      if (this.$route.query.title) {
        menuIndex = this.solutionMenuList.findIndex(item => {
          return item.name === this.$route.query.title
        })
        soluData = menuIndex > -1 && this.solutionMenuList[menuIndex] && this.solutionMenuList[menuIndex].children ? this.solutionMenuList[menuIndex].children : []
        if (menuIndex > -1) {
          if (this.$route.query.title1) {
            twoMenuIndex = soluData.findIndex(item => {
              return item.name === this.$route.query.title1
            })
          } else {
            twoMenuIndex = -1
          }
          if (menuIndex > -1 && twoMenuIndex === -1) {
            if (soluData.length) {
              soluData.forEach(ele => {
                if (ele.children && ele.children.length) {
                  soluDataList.push(...ele.children)
                }
              })
            }
          } else if (menuIndex > -1 && twoMenuIndex > -1) {
            soluDataList = soluData[twoMenuIndex].children || []
          }
          // soluDataList = menuIndex > -1 && soluData[menuIndex] && soluData[menuIndex].children ? soluData[menuIndex].children : []
        }
      } else {
        menuIndex = this.solutionMenuList.length ? this.menuIndex : -1
        twoMenuIndex = -1
        soluData = this.solutionMenuList[menuIndex].children || []
        soluData.forEach(item => {
          if (item.children && item.children.length > 0) {
            soluDataList.push(...item.children)
          }
        })
        // this.solutionMenuList.forEach(parItem => {
        //   if (parItem.children && parItem.children.length > 0) {
        //     // soluData.push(...parItem.children)
        //     parItem.children.forEach(item => {
        //       if (item.children && item.children.length > 0) {
        //         soluDataList.push(...item.children)
        //       }
        //     })
        //   }
        // })
      }
      this.soluData = soluData
      this.menuIndex = menuIndex
      this.twoMenuIndex = twoMenuIndex
      this.soluDataList = soluDataList
    },
    // 获取解决方案数据
    getSolutionData () {
      // http
      this.$store.commit('setLoadStatus', true)
      this.$request.postParam(`/front/user/home/homeSolution/findSolutionTree`)
        .then(data => {
          this.solutionMenuList = data || []
          this.updataData()
        })
        // eslint-disable-next-line handle-callback-err
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    },
    // 跳转详情
    jumpToDetail (name, id) {
      let params = {
        title: this.menuIndex > -1 ? this.solutionMenuList[this.menuIndex].name : '',
        title1: this.twoMenuIndex > -1 ? this.soluData[this.twoMenuIndex].name : '',
        key: name,
        id: id
      }
      this.$router.push({ name: 'planContent', query: params })
    }
  },
  created () {
    this.getSolutionData()
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>
.yjlm {
  line-height: 40px;
  color: #333;
  border-right: 2px #eee solid;
  padding: 0px 20px;
  height: 40px;
  width: auto;
  display: table;
  float: left;
}
.yjlm:hover {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.yjlmactive {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.ejlm {
  border-right: 0px !important;
}
.ejlm:hover {
  background: transparent !important;
  border-right: 0px !important;
  color: #1d65a8 !important;
}
.ejlmac {
  background: transparent !important;
  border-right: 0px !important;
  color: #1d65a8 !important;
}
.menu_list:hover {
  cursor: pointer;
}
.productHref {
  cursor: pointer;
  color: #333;
}
.goods-list-tool {
  width: 100%;
  height: 38px;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
}
.goods-list-tool ul {
  padding-left: 15px;
  list-style: none;
}
.goods-list-tool li {
  cursor: pointer;
  float: left;
}
.goods-list-tool span {
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-left: none;
  line-height: 36px;
  background-color: #fff;
}
.goods-list-tool span:hover {
  border: 1px solid #e4393c;
}
.goods-list-tool i:hover {
  color: #e4393c;
}
.goods-list-tool-active {
  color: #fff;
  border-left: 1px solid #ccc;
  background-color: #e4393c !important;
}
.goods-show-info {
  width: 23%;
  /* padding: 10px; */
  /* margin: 15px 8px 0px 8px; */
  /* border: 1px solid #f0f0f0; */
  cursor: pointer;
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 23px;
  float: left;
  background: #fff;
  height: 220px;
}
.goods-show-img {
  width: 100%;
  /* min-width: 247px;
  height: 320px; */
}
.goods-show-price {
  margin-top: 6px;
}
.goods-show-detail {
  font-size: 14px;
  margin: px 0px;
  padding: 10px;
  height: 80px;
  line-height: 30px;
  border-top: 1px #eee solid;
}
.tags {
  color: #005aa0;
}
.goods-show-num {
  font-size: 12px;
  margin-bottom: 6px;
  color: #009688;
}
.goods-show-num span {
  color: #005aa0;
  font-weight: bold;
}
.goods-show-seller {
  font-size: 12px;
  color: #e4393c;
}
.goods-page {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.detailDesc {
  line-height: 1.5rem;
  color: #999;
}
</style>
